'use client';
import { createContext } from 'react';
import { useNonNullishContext } from '../../hooks/use-non-nullish-context.js';

const ButtonbarContext = createContext(null);
const useButtonbarContext = ()=>useNonNullishContext(ButtonbarContext);
const ButtonbarButtonContext = createContext(void 0);
const useButtonbarButtonContext = ()=>useNonNullishContext(ButtonbarButtonContext);

export { ButtonbarButtonContext, ButtonbarContext, useButtonbarButtonContext, useButtonbarContext };
